/** @format */

import LoadingSpinner from '@atoms/LoadingSpinner';
import { css } from '@emotion/react';
import React, { ReactNode, SyntheticEvent } from 'react';
import { StyledButton } from './styled';

//<editor-fold desc="Component">
export interface ButtonProps {
  children?: ReactNode;
  onClick?: (event: SyntheticEvent) => void | null;
  warning?: boolean;
  error?: boolean;
  primary?: boolean;
  disabled?: boolean;
  active?: boolean;
  hasDecorator?: boolean;
  busy?: boolean;
}

const ButtonRender = (props: ButtonProps, ref) => {
  const onClick = props.disabled || props.busy ? () => null : props.onClick;

  return (
    <StyledButton {...props} ref={ref} onClick={onClick}>
      {props.busy ? (
        <LoadingSpinner
          css={css`
            svg {
              height: 10px;
            }
          `}
        />
      ) : (
        props.children
      )}
    </StyledButton>
  );
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(ButtonRender);

Button.displayName = 'Button';

Button.defaultProps = {
  children: <>Button</>,
  onClick: () => null,
  warning: false,
  error: false,
  disabled: false,
  active: false,
  hasDecorator: false,
  busy: false,
};
//</editor-fold>

export default Button;
